import axios from 'axios'
// import VueCookies from 'vue-cookies'

const apiClient = axios.create({
  baseURL: `${process.env.VUE_APP_API_URL}`,
  withCredentials: false,
  headers: {
    Accept: 'application/json',
    'Content-type': 'application/json',
  },
  timeout: 10000 //Throw error if API call takes longer than 10 sec//
})

apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.authorization = 'Bearer '+ token;
    }
    return config;
  },
  (error) => Promise.reject(error),
);


export default {
    // services for ACCOUNTS //
    getAccounts() {
      return apiClient.get('/accounts') //API call that fetch all accounts in json object//
    },
    getAccount(id) {
      return apiClient.get('/accounts/' + id) // API call to tell server which account to fetch//
    },
    postAccount(account) {
      return apiClient.post('/accounts', account)
    },
    updateAccount(id, account) {
      return apiClient.put('/accounts' + id, account)
    },
    deleteAccounts() {
      return apiClient.delete('/accounts') //API call that fetch all accounts in json object//
    },
    deleteAccount(id) {
      return apiClient.delete('/accounts/' + id) // API call to tell server which account to fetch//
    },
  // services for CLIENT //
  getClients() {
    // console.log('$$$$$$$',VueCookies.get('token'))
    return apiClient.get('/clients') //API call that fetch all clients in json object//
  },
  getClient(id) {
    return apiClient.get('/clients/' + id) // API call to tell server which client to fetch//
  },
  postClient(client) {
    return apiClient.post('/clients', client)
  },
  addClient(client) {
    return apiClient.post('/register/client', client)
  },
  updateClient(client) {
    return apiClient.put('/clients/' + client.id, client)
  },
  deleteClients() {
    return apiClient.delete('/clients') //API call that fetch all products in json object//
  },
  deleteClient(id) {
    return apiClient.delete('/clients/' + id) // API call to tell server which product to fetch//
  },
  profileCompleteness() {
    return apiClient.get('/check/client/profile/completeness')
  },
  // services for USER //
  getUsers() {
    return apiClient.get('/users') //API call that fetch all users in json object//
  },
  getUser(id) {
    return apiClient.get('/users/' + id) // API call to tell server which client to fetch//
  },
  postUser(user) {
    return apiClient.post('/users', user)
  },
  updateUser(id, user) {
    return apiClient.put('/users' + id, user)
  },
  deleteUsers() {
    return apiClient.delete('/users') //API call that fetch all products in json object//
  },
  deleteUser(id) {
    return apiClient.delete('/users/' + id) // API call to tell server which product to fetch//
  },
    // services for TEAM MEMBERS //
    getTeamMembers() {
      return apiClient.get('/teamMembers') //API call that fetch all team members in json object//
    },
    getTeamMember(id) {
      return apiClient.get('/teamMembers/' + id) // API call to tell server which team members to fetch//
    },
    updateTeamMember(id, cleaner) {
      return apiClient.put('/teamMembers' + id, cleaner)
    },
    getCleaner() {
      return apiClient.get('/cleaner')
    },
    updateCleaner(cleaner) {
      return apiClient.post('/update/cleaner', cleaner)
    },
    deleteTeamMembers() {
      return apiClient.delete('/teamMembers') //API call that fetch all team members  s in json object//
    },
    deleteTeamMember(id) {
      return apiClient.delete('/teamMembers/' + id) // API call to tell server which team members   to fetch//
    },
    changePassword(credentials) {
      return apiClient.post('/change/password', credentials)
    },
    fetchUserShippingDetails() {
      return apiClient.get('/user/shippingDetails') 
    },
    saveUserShippingDetails(shippingData) {
      return apiClient.post('/user/shippingDetails', shippingData) 
    }
}
